import axios, { AxiosInstance } from "axios";

const AxiosInstanceToken = (): AxiosInstance => {
  const instance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_TOKEN_BASE_URL,
    auth: {
      username: process.env.NEXT_PUBLIC_CLIENT_ID,
      password: process.env.NEXT_PUBLIC_CLIENT_SECRET,
    },
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
  });
  return instance;
};

const AxiosInstanceBase = (): AxiosInstance => {
  const instance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
    headers: {
      "content-type": "application/json",
    },
  });
  return instance;
};

export { AxiosInstanceToken, AxiosInstanceBase };
